import './style.modules.scss'

import React from 'react'
import xss from 'xss'

import { PaginationProps } from './PaginationProps.type'

export const Pagination = ({
  totalPages,
  currentPage,
  getPageHref
}: PaginationProps) => {
  const renderPageLink = (
    label: string | number,
    page?: number,
    options?: { active?: boolean; disabled?: boolean; ellipsis?: boolean },
    index?: number
  ) => {
    const classNames = ['Pagination-item u-decoUnbulleted']
    if (options?.active) classNames.push('is-active')
    if (options?.disabled) classNames.push('is-disabled')
    if (options?.ellipsis)
      classNames.push(
        'Pagination-item--ellipsis u-paddingVert4 u-paddingHoriz8'
      )

    if (options?.ellipsis || !page) {
      return (
        <li key={`page-${label}-${index}`} className={classNames.join(' ')}>
          {label}
        </li>
      )
    }

    const isPrev = label === 'prev'
    const isNext = label === 'next'

    return (
      <li key={`page-${label}`} className={classNames.join(' ')}>
        <a
          href={xss(getPageHref(page))}
          className={`Link Pagination-link u-flexInline u-linkClean u-paddingVert4 u-paddingHoriz8${
            options?.active ? ' u-textBold' : ''
          }`}
        >
          {isPrev && (
            <>
              <span
                className="adel-material-symbols-20 u-textColorActionBlue"
                title="Previous"
                aria-label="Previous"
              >
                chevron_left
              </span>
              <span>Previous</span>
            </>
          )}
          {!isPrev && !isNext && label}
          {isNext && (
            <>
              <span>Next</span>
              <span
                className="adel-material-symbols-20 u-textColorActionBlue"
                title="Next"
                aria-label="Next"
              >
                chevron_right
              </span>
            </>
          )}
        </a>
      </li>
    )
  }

  const getPagesToRender = (): (number | 'ellipsis')[] => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    }

    const pages: (number | 'ellipsis')[] = []

    const visiblePages = new Set<number>([
      1,
      2,
      totalPages - 1,
      totalPages,
      currentPage,
      currentPage - 1,
      currentPage + 1
    ])

    const sortedPages = Array.from(visiblePages)
      .filter(page => page >= 1 && page <= totalPages)
      .sort((a, b) => a - b)
    let lastPage = 0

    for (const page of sortedPages) {
      if (page - lastPage > 1) pages.push('ellipsis')
      pages.push(page)
      lastPage = page
    }

    return pages
  }

  return (
    <ul className="Pagination u-flex">
      {currentPage > 1 && renderPageLink('prev', currentPage - 1)}

      {getPagesToRender().map((item, index) =>
        item === 'ellipsis'
          ? renderPageLink(
              '…',
              undefined,
              { ellipsis: true, disabled: true },
              index
            )
          : renderPageLink(item, item, { active: item === currentPage }, index)
      )}

      {currentPage < totalPages && renderPageLink('next', currentPage + 1)}
    </ul>
  )
}
